module.exports = __webpack_public_path__ + "static/media/24UHCHR11.e9685a6a.jpg";